import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link as A } from 'raviger';
import { I18nContext } from 'i18n';

const Breadcums = ({ bread }) => {
  const { translate } = useContext(I18nContext);

  return (
    <BreadcumsContainer>
      {bread &&
        bread.map((b, i) => (
          <React.Fragment key={i}>
            {bread.length > i + 1 && (
              <>
                <A href={translate(`breadcrumbs_${b}_url`)}>
                  {translate(`breadcrumbs_${b}_text`)}
                </A>{' '}
                {'>'}{' '}
              </>
            )}
            {bread.length === i + 1 && (
              <span>{translate(`breadcrumbs_${b}_text`)}</span>
            )}
          </React.Fragment>
        ))}
    </BreadcumsContainer>
  );
};

const BreadcumsContainer = styled.div`
  margin: 1rem 0 1rem 3rem;

  > a {
    color: #3e79e0;
  }
`;

export default Breadcums;
